module.exports = __webpack_public_path__ + "media/images/konintodoke/crown_3-c483eca37e16470e967b72af2bfef4d1.png";